{
  "id": "helios",
  "pantheon": "atlanteans",
  "name": {
    "pt-BR": "Hélio",
    "en": "Helios"
  },
  "icon": "gods/helios",
  "portrait": "gods/helios-portrait",
  "age": "mythic",
  "freeUnitsOnAgeUp": {
    "centimanus": 1
  },
  "unlocks": ["centimanus", "mirror-tower", "halo-of-the-sun", "petrification", "titanomachy"],
  "powers": ["vortex"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml MythicAgeHelios)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Age-up tech: CreateUnit 1 centimanus at the Temple (Kronos: +1 from KronosExtra*, so 2). God power Vortex (cooldown 60 s). Also enables the Mirror Tower."
  }
}
